import React from "react";
import {useTranslation} from "react-i18next";
import {useAuth} from "../auth/AuthHook";
import {withBase} from "../utils/basePath";

export function WelcomeBox() {
    const {t} = useTranslation();
    const {isLoggedIn} = useAuth();
    return (
        <div className={`flex flex-col pt-4 grow h-full w-full justify-center items-center overflow-y-auto`}>
            <div id="logo-container" className="flex flex-col justify-center items-center space-y-4">
                <img src={withBase("assets/artenai.png")} className="h-10 w-fit self-center" alt={"Arten.ai logo"}/>
                {
                    !isLoggedIn() && (
                        <div className="text-xl text-white text-center">
                            {t("Log in to access support case")}
                        </div>
                    )
                }
            </div>
        </div>
    );
}